/**
 * Киргизский телефон в форме входа: маска «700 123 456» со статичным
 * префиксом +996. Форма хранит сырые 9 цифр, гейтвею уезжает E.164.
 */

/** Сырые цифры номера без кода страны: максимум 9, ведущие 996/0 отбрасываем */
export const phoneDigits = (value: string): string =>
  value.replace(/\D/g, '').replace(/^996/, '').replace(/^0+/, '').slice(0, 9);

/** «700123456» → «700 123 456» (частичный ввод группируется по мере набора) */
export const formatKgPhone = (digits: string): string =>
  [digits.slice(0, 3), digits.slice(3, 6), digits.slice(6, 9)].filter(Boolean).join(' ');

/** E.164 для гейтвея: «+996700123456» */
export const toE164 = (value: string): string => `+996${phoneDigits(value)}`;
